import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type AccordionItem = {
  title: string;
  description: string;
  icon: React.ReactNode;
  previewImage?: string;
  previewAlt?: string;
};
type AccordionProps = {
  items: AccordionItem[];
  tone?: 'light' | 'dark';
};
export function Accordion({
  items,
  tone = 'light'
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const baseId = useId();
  return <div className={`accordion-list accordion-list--${tone}`} data-id="element-1" data-mp="2n24gm0yzvdl4">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `${baseId}-panel-${index}`;
      return <div className="accordion-item" key={item.title} data-id="element-2" data-mp="2w2axzxxtcxpk" data-mpi={index}>
            <button type="button" className={`accordion-trigger ${item.previewImage ? 'accordion-trigger--preview' : ''}`} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-3" data-mp="2s4d96w7ygdmp">
              {item.previewImage && <span className="accordion-preview" aria-hidden="true" data-id="element-4" data-mp="3l36srlf6pgq7">
                  <img src={item.previewImage} alt={item.previewAlt ?? ''} data-id="element-5" data-mp="3l3glvhvj0404" />
                </span>}
              <span className="accordion-icon" aria-hidden="true" data-id="element-6" data-mp="3q0gplm4wkuo2">
                {item.icon}
              </span>
              <span className="accordion-title" data-id="element-7" data-mp="3myzivlyfyh9">{item.title}</span>
              <ChevronDownIcon className={`chevron ${isOpen ? 'chevron--open' : ''}`} size={19} aria-hidden="true" data-id="element-8" data-mp="3mfdb2p9unxf" />
            </button>
            <div id={panelId} className={`accordion-panel ${isOpen ? 'accordion-panel--open' : ''}`} aria-hidden={!isOpen} data-id="element-9" data-mp="co6o2lyo5ky5">
              <p data-id="element-10" data-mp="2eg1q09v4ib36">{item.description}</p>
            </div>
          </div>;
    })}
    </div>;
}